import { createApp } from "vue";
import Antd from "ant-design-vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import sandboxDirective from '@/directives/sandbox';
import "@/style/index.css";

createApp(App).use(store).use(Antd).use(router).use(sandboxDirective).mount("#app");
